/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Offline_License_Invalid_ToastInputs */

const en_creator_offline_license_invalid_toast = /** @type {(inputs: Creator_Offline_License_Invalid_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline license is expired or invalid`)
};

const fr_creator_offline_license_invalid_toast = /** @type {(inputs: Creator_Offline_License_Invalid_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La licence hors ligne est expiree ou invalide`)
};

const de_creator_offline_license_invalid_toast = /** @type {(inputs: Creator_Offline_License_Invalid_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Offline-Lizenz ist abgelaufen oder ungültig.`)
};

const it_creator_offline_license_invalid_toast = /** @type {(inputs: Creator_Offline_License_Invalid_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La licenza offline è scaduta o non è valida`)
};

const ru_creator_offline_license_invalid_toast = /** @type {(inputs: Creator_Offline_License_Invalid_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок действия офлайн-лицензии истек или она недействительна.`)
};

const es_creator_offline_license_invalid_toast = /** @type {(inputs: Creator_Offline_License_Invalid_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La licencia sin conexión ha expirado o no es válida`)
};

const zh_cn2_creator_offline_license_invalid_toast = /** @type {(inputs: Creator_Offline_License_Invalid_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线许可证已过期或无效`)
};

const ja_creator_offline_license_invalid_toast = /** @type {(inputs: Creator_Offline_License_Invalid_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフラインライセンスが期限切れまたは無効です`)
};

const hi_creator_offline_license_invalid_toast = /** @type {(inputs: Creator_Offline_License_Invalid_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़लाइन लाइसेंस की समय सीमा समाप्त हो गई है या वह अमान्य है।`)
};

const pt_pt2_creator_offline_license_invalid_toast = /** @type {(inputs: Creator_Offline_License_Invalid_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A licença offline expirou ou é inválida.`)
};

/**
* | output |
* | --- |
* | "Offline license is expired or invalid" |
*
* @param {Creator_Offline_License_Invalid_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_offline_license_invalid_toast = /** @type {((inputs?: Creator_Offline_License_Invalid_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Offline_License_Invalid_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_offline_license_invalid_toast(inputs)
	if (locale === "de") return de_creator_offline_license_invalid_toast(inputs)
	if (locale === "it") return it_creator_offline_license_invalid_toast(inputs)
	if (locale === "ru") return ru_creator_offline_license_invalid_toast(inputs)
	if (locale === "es") return es_creator_offline_license_invalid_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_offline_license_invalid_toast(inputs)
	if (locale === "ja") return ja_creator_offline_license_invalid_toast(inputs)
	if (locale === "hi") return hi_creator_offline_license_invalid_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_offline_license_invalid_toast(inputs)
	return en_creator_offline_license_invalid_toast(inputs)
});